import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgxPaginationModule} from 'ngx-pagination';
import {SharedModule} from "../../../shared/shared/shared.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FollowUpComponent} from "./follow-up.component";
import {ModalRequestFollowUpAddComponent} from "./modal/modal-request-follow-up-add.component";
import {ModalModule} from "ngx-bootstrap";
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    NgSelectModule,
    SharedModule,
    ReactiveFormsModule,
    ModalModule,
  ],
  declarations: [
    FollowUpComponent,
    ModalRequestFollowUpAddComponent,
  ]
})
export class FollowUpModule {
}
